
export const REFRESH_BADGES = 'REFRESH_BADGES'
export const REFRESH_ABILITIES = 'REFRESH_ABILITIES'
export const API_CALL_PENDING = 'API_CALL_PENDING'
export const API_CALL_COMPLETE = 'API_CALL_COMPLETE'
export const EXPORT_CSV = 'EXPORT_CSV'



// WEBPACK FOOTER //
// ./src/lib/enums/events/app.js